import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/NavBar/navbar";
import Intro from "./components/Intro/intro";
import AboutUs from "./components/AboutUs/aboutUs";
import Contact from "./components/Contact/contact";
import News from "./components/News/news";
import WhatIsRugby from "./components/WhatIsRugby/whatIsRugby";
import Login from "./pages/Login";  
import Signup from "./pages/SignUp";
import CreatePost from "./components/CreatePost";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setUser(true);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/" element={<Intro />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/news" element={<News />} />
          <Route path="/whatIsRugby" element={<WhatIsRugby />} />
          <Route path="/contact" element={<Contact />} />
          {/* 🔒 Protect the login/signup pages */}
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/" />} />
          <Route path="/create-post" element={<CreatePost />} />  {/* ✅ New Route */}
   
        </Routes>
      </div>
    </Router>
  );
}

export default App;
